var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"md-icon",attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":_vm.currentIcon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }